import { render, staticRenderFns } from "./EmployeeSettingsHolidays.vue?vue&type=template&id=b154a756&"
import script from "./EmployeeSettingsHolidays.vue?vue&type=script&lang=js&"
export * from "./EmployeeSettingsHolidays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports